import {combineReducers} from 'redux'
import types from 'actions/types'

export const mailchimpStatus = (state = null, action) => {
  switch (action.type) {
    case types.MAILCHIMP_ENABLED_SUCCESS:
      return action.data
    case types.MAILCHIMP_DISABLE_SUCCESS:
      return action.data
    case types.MAILCHIMP_STATUS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const lists = (state = [], action) => {
  switch (action.type) {
    case types.MAILCHIMP_LOAD_LISTS_ATTEMPT:
      return []
    case types.MAILCHIMP_LOAD_LISTS_SUCCESS:
      return action.data
    case types.MAILCHIMP_LOAD_LISTS_FAILURE:
      return []
    default:
      return state
  }
}

export const mergeFields = (state = [], action) => {
  switch (action.type) {
    case types.MAILCHIMP_LOAD_MERGE_FIELDS_ATTEMPT:
      return []
    case types.MAILCHIMP_LOAD_MERGE_FIELDS_SUCCESS:
      return action.data
    case types.MAILCHIMP_LOAD_MERGE_FIELDS_FAILURE:
      return []
    default:
      return state
  }
}

export default combineReducers({
  mailchimpStatus,
  lists,
  mergeFields,
})
